<template>
  <div>
    <div class="container">
      <section class="hiddenSp">
        <h2>
          <img src="@/assets/icon/question-circle.svg" alt="" />
          よくある質問
        </h2>
        <div class="content">
          <p>
            イベントのご利用について、様々な疑問にお答えしています。
          </p>
          <Button
            primary
            class="button"
            label="詳細はこちら"
            :handleClick="() => $router.push('/faq')"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/elements/Button.vue'

export default {
  name: 'EventFooter',
  components: { Button },
  setup() {
    //
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.container {
  @include mixins.media() {
    border: 1px solid var.$color-border-gray;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
}
h2 {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var.$color-sub-bg-g;
  font-weight: 300;
  font-size: 1.7rem;
  line-height: 5rem;
  img {
    margin-right: 5px;
  }
}
p {
  letter-spacing: 0.02rem;
}
.report {
  display: flex;
  align-items: center;
  height: 50px;
  + .report {
    border-top: 1px solid var.$color-border-gray;
  }
}
.content {
  padding: 15px 20px;
}
.button {
  margin: 20px auto;
}
</style>
